module.exports = __webpack_public_path__ + "static/media/blazing-fast-optimized.faa73fa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/02-blazing-fast/images/blazing-fast-optimized.jpg
// module id = 928
// module chunks = 0